import { useState } from 'react';

export default function useImageNavigation() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleImageCurrentIndex = (index: number) => {
    setCurrentImageIndex(index);
  };

  return {
    handleImageCurrentIndex,
    currentImageIndex
  };
}
